
      import { Buffer } from "buffer";
      window.Buffer = window.Buffer || Buffer;

      var env = "staging"

      if(env !== 'release') {
        console.info(`environment: ${env}`)
      }
    